import isNull from 'lodash/isNull'
import isUndefined from 'lodash/isUndefined'
import { Facility } from 'apps/marketplace/apiTypes/facilities'
import { ShipperFacility } from 'apps/marketplace/apiTypes/shipperFacilities'
import { TFacilityOverride } from '../components/FacilityExtra/FacilityExtraFormSchema'
import { TFacilityScheduleSchema } from '../components/FacilitySchedule/FacilityScheduleForm'
import { IScheduleRule, TFacilitySchedule, TFacilityScheduleRequest } from './schedulingRules'

export interface IFacilityScheduleView {
  sop: TFacilityOverride | undefined
  schedulingNotes: TFacilityOverride
  documents: {
    overridden: boolean
    value: {
      id?: number | undefined
      fileName?: string | undefined
      fileUrl?: string | undefined
    }[]
  }
  rules: {
    overridden: boolean
    value: IScheduleRule[]
  }
}

export const EMPTY_SCHEDULE: Readonly<IFacilityScheduleView> = {
  sop: { overridden: false, value: '' },
  schedulingNotes: { overridden: false, value: '' },
  documents: { overridden: false, value: [] },
  rules: { overridden: false, value: [] },
}

export const getFacilitySchedule = (facility: Facility): IFacilityScheduleView => {
  const { schedule } = facility

  if (isUndefined(schedule) || isNull(schedule)) {
    return EMPTY_SCHEDULE
  }

  return {
    sop: { overridden: false, value: schedule.sop || '' },
    documents: { overridden: false, value: schedule.documents || [] },
    rules: { overridden: false, value: schedule.rules || [] },
    schedulingNotes: { overridden: false, value: schedule.schedulingNotes || '' },
  }
}

export type TShipperFacilitySchedule = Required<Pick<ShipperFacility, 'schedule'>>['schedule']

export const getShipperFacilitySchedule = (
  shipper: ShipperFacility | undefined
): IFacilityScheduleView => {
  const { schedule } = shipper || {}

  if (isUndefined(schedule) || isNull(schedule)) {
    return EMPTY_SCHEDULE
  }

  const { documents, rules, schedulingNotes, sop } = schedule

  return {
    sop: { overridden: sop?.overridden || false, value: sop?.value || '' },
    documents: { overridden: documents?.overridden || false, value: documents?.value || [] },
    rules: { overridden: rules?.overridden || false, value: rules?.value || [] },
    schedulingNotes: {
      overridden: schedulingNotes?.overridden || false,
      value: schedulingNotes?.value || '',
    },
  }
}

export const onlyModified = (
  original: TFacilitySchedule,
  updated: TFacilityScheduleSchema
): Partial<TFacilityScheduleRequest> => {
  const result: Partial<TFacilityScheduleRequest> = {}
  if (original.sop !== updated.sop) {
    result.sop = updated.sop
  }
  if (original.schedulingNotes !== updated.schedulingNotes) {
    result.schedulingNotes = updated.schedulingNotes
  }
  return result
}
